var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/isarray/index.js
// module id = 189
// module chunks = 3 4 17 18 26 31 39 41 43 44 46 48 62 64 78 79 82 87 143 154 164